import React, { useState } from 'react';
import '../../../entrydoor.css';

const GlassDividersVertical = ({ value, onChange, label = 'Vertical:', disabled = false }) => {
    const [selectedGlassDividersVertical, setSelectedGlassDividersVertical] = useState(value || "");
     const [GlassDividersVerticalError, setGlassDividersVerticalError] = useState("");

    const handleGlassDividersVerticalChange = (e) => {
        //setSelectedGlassDividersVertical(e.target.value);
        validateGlassDividersVertical(e.target.value);
        onChange(e.target.value);
    };
    const validateGlassDividersVertical = (value) => {
        const numericValue = value.replace(/\D/g, ""); // Allow only numbers
        setSelectedGlassDividersVertical(numericValue);
      
        if (numericValue && (numericValue < 0 || numericValue > 10)) {
            setGlassDividersVerticalError('must be between 0" and 10"');
        } else {
            setGlassDividersVerticalError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display: "none" }} disabled={disabled} htmlFor="GlassDividersVertical">{label}</label>
            <input style={{ display: "none" }}
                disabled={disabled}
                id="GlassDividersVertical"
                value={selectedGlassDividersVertical}
                onChange={handleGlassDividersVerticalChange}
            >
            </input>
            {GlassDividersVerticalError && <p className="error">{GlassDividersVerticalError}</p>}
        </div>
    );
};

export default GlassDividersVertical;
